import { render, staticRenderFns } from "./OwnerSidebar.vue?vue&type=template&id=2bbfb7be&scoped=true&"
import script from "./OwnerSidebar.vue?vue&type=script&lang=js&"
export * from "./OwnerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfb7be",
  null
  
)

export default component.exports